import { createSlice } from "@reduxjs/toolkit";
import { getWarehouseList } from "../../reduxApi/admin/WarehouseReduxApi";

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState: {
    status: "idel",
    isFiltered: false,
    warehouse: [],
  },
  reducers: {
    // setFilteredStatus: (state, action) => {
    //     state.isFiltered = action.payload;
    // },
    // deletetermsAndConditionAction: (state, action) => {
    //     action.payload.forEach((id) => {
    //         const index = state.termsAndCondition.findIndex((item) => item.ROWID === id);
    //         if (index !== -1) {
    //             state.termsAndCondition.splice(index, 1);
    //         }
    //     });
    // },
    // updatetermsAndConditionAction: (state, action) => {
    //     const index = state.termsAndCondition.findIndex((item) => item.ROWID === action.payload.ROWID)
    //     if (index != -1) {
    //         state.termsAndCondition.splice(index, 1, { termsAndConditions: action.payload })
    //     }
    // },

    addWarehouseAction: (state, action) => {
      console.log("warehouse action.payload", action.payload);

      state.warehouse.unshift(action.payload);
    },

    updateWarehouseAction: (state, action) => {
      const index = state.warehouse.findIndex(
        (item) => item.ROWID === action.payload.ROWID,
      );

      if (index !== -1) {
        state.warehouse.splice(index, 1, action.payload);
      }
    },

    deleteWarehouseAction: (state, action) => {
  state.warehouse = state.warehouse.filter(
    (item) => item.ROWID !== action.payload
  );
},
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouseList.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getWarehouseList.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // state.termsAndCondition = action.payload.data.termAndConditions;
        state.termsAndCondition = action.payload.data.termAndConditions || [];
        // state.warehouse = action.payload?.data?.data || [];
      });
  },
});
export const { addWarehouseAction, updateWarehouseAction, deleteWarehouseAction } =
  warehouseSlice.actions;
export default warehouseSlice.reducer;
